import { NodeEditorSubmitResult, JourneyNode } from '../types/journey-nodes'
import { updateStepConfig } from '@pushly/models/lib/structs/journeys'
import type { IActionStep, INotificationActionParams } from '@pushly/models/lib/structs/journeys'

export function handleNodeParamsUpdate(
    node: JourneyNode<IActionStep>,
    params: Partial<INotificationActionParams>,
    options?: { clearNotificationId?: boolean },
): NodeEditorSubmitResult {
    const step = node.data.step

    const mergedParams = {
        ...step.configuration.params,
        ...params,
    }

    // When the user edits a notification, clear notification_id so the inline
    // notification payload survives journey-wizard.tsx's dedup logic (which
    // strips `notification` when both `notification_id` and `notification`
    // are present, assuming the notification was un-edited).
    if (options?.clearNotificationId) {
        delete mergedParams.notification_id
    }

    return {
        nodeId: node.id,
        step: updateStepConfig(step, {
            params: mergedParams,
        } as Partial<typeof step.configuration>),
    }
}
